import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Popup from "../components/PopUP";
import api from "../Api";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import TableFooter from "../components/TableFooter";
import {IMAGE_URL} from "../utils/constants";


const DirectQuestionSetGameSets = () => {
  const [popupMessage, setPopupMessage] = useState("Question sets fetching...");
  const [PopUpMessageType, setPopUpMessageType] = useState("info");

  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [loading, setLoading] = useState(true);
  const [endPoint, setEndPoint] = useState();
  const [sets, setSets] = useState([]);
  const [gameName, setGameName] = useState();
  const [activeTab, setActiveTab] = useState("sets");

  const [pagination, setPagination] = useState({
    count: 0,
    total_pages: 0,
    next: 0,
    previous: 0,
  });
  const [currentPage, setCurrentPage] = useState(1);

  const [summary, setSummary] = useState({
    approved: 0,
    unapproved: 0,
    total: 0,
  });

  const [tokenUsage, setTokenUsage] = useState([]);
  const [tokenPagination, setTokenPagination] = useState({
    count: 0,
    total_pages: 0,
    next: 0,
    previous: 0,
  });
  const [currentTokenPage, setCurrentTokenPage] = useState(1);
  const [tokenSummary, setTokenSummary] = useState({
    open_ai: 0,
    claude_ai: 0,
    total: 0,
  });

  useEffect(() => {
    // Reset token usage data when the game type/pathname changes
    setTokenUsage([]);
    setCurrentTokenPage(1);
  }, [pathname]);

  useEffect(() => {
    setActiveTab("sets");
    const fetchData = async () => {
      const pathParts = pathname.split("/").filter(Boolean);

      const gameType = pathParts[1];

      let endpoint = null;

      if (gameType === "trivia") {
        endpoint = "/trivia/";
      }
      else if (gameType === "image-game") {
        endpoint = "/image-game/"
      }
      else if (gameType === "encyclopaedia") {
        endpoint = "/encyclopaedia/"
      }

      console.info("Determined game type:", gameType, "with endpoint:", endpoint);

      if (gameType === "image-game") {
        setGameName("Plane spotter")
      }
      else if(gameType === "encyclopaedia"){
        setGameName("Citius. Altius. Longius.")
      }
      else {
        setGameName("Jetting Around The World")

      }

      if (!endpoint) return;
      setEndPoint(endpoint);

      const apiUrl = `${endpoint}admin/sets?page=${currentPage}`;

      try {
        const response = await api.get(apiUrl);
        console.info("API Response:", response.data);
        setSets(response.data.results);
        setPagination({
          count: response.data.count,
          total_pages: response.data.total_pages,
          next: response.data.next,
          previous: response.data.previous,
        });
        if (response.data.summary) {
          setSummary(response.data.summary);
        }
      } catch (error) {
        console.error("API Error:", error.message);
      }

      setLoading(false);
    };

    fetchData();
  }, [pathname, currentPage, loading]);

  const goToQuestions = (id) => {
    navigate(`/game-question-set${endPoint}${id}`);
  };

  const fetchTokenUsage = useCallback(async () => {
    if (!endPoint) return;
    try {
      const response = await api.get(`${endPoint}admin/token-usage?page=${currentTokenPage}`);
      setTokenUsage(response.data.results || []);
      setTokenPagination({
        count: response.data.count || 0,
        total_pages: response.data.total_pages || 0,
        next: response.data.next || 0,
        previous: response.data.previous || 0,
      });
      if (response.data.usage) {
        setTokenSummary(response.data.usage);
      }
    } catch (error) {
      console.error("Token Usage API Error:", error.message);
    }
  }, [endPoint, currentTokenPage]);

  useEffect(() => {
    if (activeTab === "token") {
      fetchTokenUsage();
    }
  }, [activeTab, fetchTokenUsage, pathname]);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  const handlePublish = async (setId) => {
    setLoading(true);
    try {
      setPopupMessage("Publishing set...");
      const response = await api.patch(`${endPoint}admin/set-action`, {
        action: "approved",
        id: setId,
      });

      if (response.status === 200 || response.status === 201) {
        setPopupMessage(response.data.detail);
        setPopUpMessageType("info")
      }
    } catch (error) {
      console.error("API Error:", error.message);
      setPopUpMessageType("danger")
      setPopupMessage(error.response?.data?.detail || "Error publishing set");
    }
    setLoading(false);
  };

  const handleReject = async (setId) => {
    setLoading(true);
    try {
      setPopupMessage("Rejecting set...");
      const response = await api.patch(`${endPoint}admin/set-action`, {
        action: "unapproved",
        id: setId,
      });

      if (response.status === 200 || response.status === 201) {
        setPopupMessage(response.data.detail);
        setPopUpMessageType("info")
      }
    } catch (error) {
      console.error("API Error:", error.message);
      setPopUpMessageType("danger")
      setPopupMessage(error.response?.data?.detail || "Error unapproving set");
    }
    setLoading(false);
  };


  return (
    <>
      <Popup message={popupMessage} type={PopUpMessageType} onClose={() => setPopupMessage("")} />
      <Sidebar />
      <div className="main-wrapper">
        <Header />
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        {/* <GameBreadcrumb quizId="" /> */}
                        <h1 className="mb-2 mt-3 text-capitalize text-white">{gameName && gameName.replace("-", " ")}</h1>
                      </div>
                    </div>
                  </div>

                  {/* Tabs */}
                  <ul className="nav nav-tabs mt-4" id="gameSetsTabs">
                    <li className="nav-item">
                      <button
                        className={`nav-link ${activeTab === "sets" ? "active" : ""}`}
                        onClick={() => handleTabChange("sets")}
                      >
                        <i className="fa-solid fa-table-list me-2"></i>
                        Question Sets
                      </button>
                    </li>
                    <li className="nav-item">
                      <button
                        className={`nav-link ${activeTab === "token" ? "active" : ""}`}
                        onClick={() => handleTabChange("token")}
                      >
                        <i className="fa-solid fa-coins me-2"></i>
                        Token Usage
                      </button>
                    </li>
                  </ul>

                  <div className="tab-content mt-3">

                    {/* ── Tab 1: Question Sets ── */}
                    {activeTab === "sets" && (
                      <>
                        {/* Summary Cards */}
                        <div className="row gy-3 mb-4">
                          <div className="col-sm-4">
                            <div
                              className="card border-0 shadow-sm text-center p-3"
                              style={{ borderRadius: "12px", background: "#f0fdf4" }}
                            >
                              <div className="fw-bold fs-4" style={{ color: "#16a34a" }}>
                                {summary.approved}
                              </div>
                              <div className="text-muted small mt-1">Approved</div>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div
                              className="card border-0 shadow-sm text-center p-3"
                              style={{ borderRadius: "12px", background: "#fef9c3" }}
                            >
                              <div className="fw-bold fs-4" style={{ color: "#ca8a04" }}>
                                {summary.unapproved}
                              </div>
                              <div className="text-muted small mt-1">Unapproved</div>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div
                              className="card border-0 shadow-sm text-center p-3"
                              style={{ borderRadius: "12px", background: "#eff6ff" }}
                            >
                              <div className="fw-bold fs-4" style={{ color: "#2563eb" }}>
                                {summary.total}
                              </div>
                              <div className="text-muted small mt-1">Total</div>
                            </div>
                          </div>
                        </div>

                        <div className="common-table-wrapper mt-4">
                          <div className="common-table-filter-wrapper">
                            <div className="common-left-blk">
                              <div className="common_sub_heading_wrapper mb-0">
                                <h2>Sets listing</h2>
                              </div>
                            </div>
                          </div>

                          <div className="table-blk table-responsive">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  <th>Set ID</th>
                                  {gameName && gameName.replaceAll(" ", "").toLowerCase() === "citius.altius.longius." && (
                                      <th>Level</th>
                                  )}
                                  <th>Date Created</th>
                                  <th>Status</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {sets.map((set, index) => (
                                  <tr key={set.id}>
                                    <td>
                                      {(index + 1) + (currentPage - 1) * 20}
                                    </td>
                                    <td>{set.question_id}</td>
                                    {gameName && gameName.replaceAll(" ", "").toLowerCase() === "citius.altius.longius." && (
                                      <td>{set.level}</td>
                                     )}
                                    <td>{set.created_at}</td>
                                    <td>
                                      <span
                                        className={`td-status ${set.is_approve === true
                                          ? "st-active"
                                          : "st-inactive"
                                          } fw-semibold`}
                                      >
                                        {set.is_approve === true
                                          ? "Published"
                                          : "Not Published"}
                                      </span>
                                    </td>
                                    <td>
                                      <span className="td-action">
                                        <button
                                          className="border-0 bg-white"
                                          onClick={() => { goToQuestions(set.id); }}
                                        >
                                          <img
                                            src={IMAGE_URL+"eye-tbl-icon.svg"}
                                            alt="View"
                                          />
                                        </button>

                                        <button
                                          type="button"
                                          className="border-0 bg-white"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title="Publish"
                                          onClick={() => handlePublish(set.id)}
                                          disabled={set.is_approve}
                                        >
                                          <i className="fa-solid fa-upload"></i>
                                        </button>

                                        <button
                                          type="button"
                                          className="border-0 bg-white"
                                          data-toggle="tooltip"
                                          data-placement="top"
                                          title="Reject"
                                          onClick={() => handleReject(set.id)}
                                          disabled={!set.is_approve}
                                        >
                                          <i className="fa-solid fa-ban"></i>
                                        </button>
                                      </span>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>

                          {/* Pagination Footer */}
                          <TableFooter
                            pagination={pagination}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                          />
                        </div>
                      </>
                    )}

                    {/* ── Tab 2: Token Usage ── */}
                    {activeTab === "token" && (
                      <>
                        {/* Token Summary Cards */}
                        <div className="row gy-3 mb-4">
                          <div className="col-sm-4">
                            <div
                              className="card border-0 shadow-sm text-center p-3"
                              style={{ borderRadius: "12px", background: "#eff6ff" }}
                            >
                              <div className="fw-bold fs-4" style={{ color: "#2563eb" }}>
                                {tokenSummary.open_ai.toLocaleString()}
                              </div>
                              <div className="text-muted small mt-1">OpenAI Tokens</div>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div
                              className="card border-0 shadow-sm text-center p-3"
                              style={{ borderRadius: "12px", background: "#f5f3ff" }}
                            >
                              <div className="fw-bold fs-4" style={{ color: "#7c3aed" }}>
                                {tokenSummary.claude_ai.toLocaleString()}
                              </div>
                              <div className="text-muted small mt-1">Claude Tokens</div>
                            </div>
                          </div>
                          <div className="col-sm-4">
                            <div
                              className="card border-0 shadow-sm text-center p-3"
                              style={{ borderRadius: "12px", background: "#f0fdf4" }}
                            >
                              <div className="fw-bold fs-4" style={{ color: "#16a34a" }}>
                                {tokenSummary.total.toLocaleString()}
                              </div>
                              <div className="text-muted small mt-1">Total Tokens</div>
                            </div>
                          </div>
                        </div>

                        <div className="common-table-wrapper">
                          <div className="common-table-filter-wrapper">
                            <div className="common-left-blk">
                              <div className="common_sub_heading_wrapper mb-0">
                                <h2>LLM Token Usage</h2>
                              </div>
                            </div>
                          </div>
                          <div className="table-blk table-responsive">
                            <table className="table">
                              <thead>
                                <tr>
                                  <th>S.No</th>
                                  {endPoint === '/image-game/' && <th>Level</th>}
                                  <th>Model</th>
                                  <th>Input Tokens</th>
                                  <th>Output Tokens</th>
                                  <th>Total Tokens</th>
                                  <th>Date</th>
                                </tr>
                              </thead>
                              <tbody>
                                {tokenUsage.length === 0 ? (
                                  <tr>
                                    <td colSpan="6" className="text-center text-muted py-4">
                                      No token usage data available.
                                    </td>
                                  </tr>
                                ) : (
                                  tokenUsage.map((item, index) => (
                                    <tr key={item.id || index}>
                                      <td>{(index + 1) + (currentTokenPage - 1) * 20}</td>
                                      {endPoint === '/image-game/' && <td className="text-capitalize">{item.level || "-"}</td>}
                                      <td>{item.model || "-"}</td>
                                      <td>{item.input_tokens ?? "-"}</td>
                                      <td>{item.output_tokens ?? "-"}</td>
                                      <td>{item.total_tokens ?? "-"}</td>
                                      <td>{item.created_at || "-"}</td>
                                    </tr>
                                  ))
                                )}
                              </tbody>
                            </table>
                          </div>

                          {/* Token Pagination Footer */}
                          <TableFooter
                            pagination={tokenPagination}
                            currentPage={currentTokenPage}
                            setCurrentPage={setCurrentTokenPage}
                          />
                        </div>
                      </>
                    )}

                  </div> {/* end tab-content */}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default DirectQuestionSetGameSets;

